import React, { FC, SVGProps } from 'react';

const EyeOpen: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.5 4.59311C3.9375 4.59311 1.3125 10.5 1.3125 10.5C1.3125 10.5 3.9375 16.4056 10.5 16.4056C17.0625 16.4056 19.6875 10.5 19.6875 10.5C19.6875 10.5 17.0625 4.59311 10.5 4.59311Z"
      stroke="#343643"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 13.125C11.9497 13.125 13.125 11.9497 13.125 10.5C13.125 9.05025 11.9497 7.875 10.5 7.875C9.05025 7.875 7.875 9.05025 7.875 10.5C7.875 11.9497 9.05025 13.125 10.5 13.125Z"
      stroke="#343643"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeOpen;
